module.exports = __webpack_public_path__ + "img/plus-green.5897518d.svg";